
<template>

  <div id="app" class="wrapper">
    
    <Headernav v-if="$route.name!=='Home'"/>
    <transition name="fade" mode="out-in"> 
      <!-- <div class="homediv col-md-12 col-md-offset-12 container" v-if="$route.name==='Home'" style="text-align:center">
        <div style="color: rgba(0,0,0,0.6); margin-top: 16px;text-align: center"></div> 
        <Radialmenucontainer @HomeDivVisibility="setHomeDivVisibility"/>
        <button v-on:click="enterdetails" class="btn btn-primary">Start >></button>
      </div> -->
    </transition>
    <transition name="fade" mode="out-in">
        <div class="aboutdiv col-md-12 col-md-offset-12" v-if="$route.name==='About'">
            <Radialmenucontainer @HomeDivVisibility="setHomeDivVisibility"/>  
        </div>
    </transition>
    <transition name="fade" mode="out-in" >
        <div class="objectivesdiv col-md-12 col-md-offset-12" v-if="$route.name==='Objectives'">
            <Radialmenucontainer @HomeDivVisibility="setHomeDivVisibility"/>  
        </div>
        
    </transition>
    
    <transition name="fade" mode="out-in">
      <div class="eventsdiv col-md-12 col-md-offset-12" v-if="$route.name==='Events'">
        <Radialmenucontainer @HomeDivVisibility="setHomeDivVisibility"/>  
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div class="sponsordiv col-md-12 col-md-offset-12" v-if="$route.name==='Sponsor'">
        <Radialmenucontainer @HomeDivVisibility="setHomeDivVisibility"/>  
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div class="gallerydiv col-md-12 col-md-offset-12" v-if="$route.name==='Gallery'">
        <Radialmenucontainer @HomeDivVisibility="setHomeDivVisibility"/>  
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div class="photogallerydiv col-md-12 col-md-offset-12" v-if="$route.name==='PhotoGallery'">
        <Radialmenucontainer @HomeDivVisibility="setHomeDivVisibility"/>  
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div class="videogallerydiv col-md-12 col-md-offset-12" v-if="$route.name==='VideoGallery'">
        <Radialmenucontainer @HomeDivVisibility="setHomeDivVisibility"/>  
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div class="contactdiv col-md-12 col-md-offset-12" v-if="$route.name==='Contact'">
        <Radialmenucontainer @HomeDivVisibility="setHomeDivVisibility"/>  
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div class="membersroundup col-md-12 col-md-offset-12" v-if="$route.name==='Membersroundup'">
        <Radialmenucontainer @HomeDivVisibility="setHomeDivVisibility"/>  
      </div>
    </transition>
    <Promotionitem v-if="$route.name!=='Home'"/>
    <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
              <router-view ></router-view>
    </transition>
    <Footernav v-if="$route.name!=='Home'"/>
    
  </div>
</template>

<script>



import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Headernav from '@/components/sections/Headernav'
import Footernav from '@/components/sections/Footernav'
import Radialmenucontainer from '@/components/sections/Radialmenucontainer'
import Promotionitem from '@/components/sections/Promotionitem'


export default {
  name: 'app',
  components: {
    Radialmenucontainer,
    Headernav,
    Footernav,
    Promotionitem
    
  },
  data() {
    return {
      prevHeight: 0,
      hideHomeDiv: true,
      backgroundimage:'assets/hpcaheader2.png'
    };
  },
   methods: {
    beforeLeave(element) {
      // https://markus.oberlehner.net/blog/vue-router-page-transitions/
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);
      element.style.height = this.prevHeight;
      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
    setHomeDivVisibility(boolvalue) {
          this.hideHomeDiv = boolvalue;
      },
    enterdetails: function (event) {
      
     this.$router.push({name:'About'});
    }
  },
  
  beforeMount(){
    //alert($route.name);
    this.hideHomeDiv= false;
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue